import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Dropdown, Row, Col, Button } from 'antd';
import AuthContext from '@packages/contexts/auth/authContext';
import StyledAppNavbar from './AppNavbar.styles';

const AppNavbar: React.FC = (): React.ReactElement => {
    const { user, closeSession } = useContext(AuthContext);

    const dropDownMenuOpts: React.ReactElement = (
        <Menu>
            <Menu.Item key="0">
                <Button type="link" title="Close session" onClick={closeSession} size="small" className="text-dark">
                    Close session
                </Button>
            </Menu.Item>
        </Menu>
    );

    return (
        <StyledAppNavbar>
            <Row>
                <Col span={3} xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 3 }}>
                    <Link to="/admin" title="Home">
                        <img
                            src="/assets/images/stuart-brand-logo.svg"
                            alt="Stuart company logo"
                            className="brand-logo"
                        />
                    </Link>
                </Col>
                <Col span={19} xs={{ span: 16 }} sm={{ span: 16 }} md={{ span: 19 }} className="text-right">
                    <a
                        id="link-api-documentation"
                        href="https://stuart-solutions.api-docs.io"
                        target="blank"
                        title="API Documentation"
                        className="text-black-50"
                    >
                        API Documentation
                    </a>
                </Col>
                <Col span={2} xs={{ span: 2 }} sm={{ span: 2 }} md={{ span: 2 }} className="text-right">
                    <Dropdown overlay={dropDownMenuOpts} trigger={['click']}>
                        <Button
                            type="link"
                            title={`${user && user.role}`}
                            size="small"
                            className="ant-dropdown-link text-dark"
                            onClick={(e: React.MouseEvent<HTMLButtonElement>): void => e.preventDefault()}
                        >
                            <img
                                src="/assets/images/user-circled-icon.svg"
                                alt="User profile icon"
                                className="bi bi-person-circle"
                            />
                        </Button>
                    </Dropdown>
                </Col>
            </Row>
        </StyledAppNavbar>
    );
};

export default AppNavbar;
